<div class="relative">
  <!-- Trigger -->
  @if (borderless()) {
    <button
      type="button"
      (click)="toggle()"
      class="inline-flex items-center gap-1 text-xs cursor-pointer"
    >
      <span [ngClass]="selectedLabel() ? 'text-navy-900' : 'text-accent-500'">
        {{ selectedLabel() || placeholder() }}
      </span>
      <img
        src="/icons/chevron-down-icon.svg"
        class="w-3 h-3 shrink-0 opacity-40 transition-transform duration-150"
        [ngClass]="open() ? 'rotate-180' : ''"
        alt=""
      />
    </button>
  } @else {
    <button
      type="button"
      (click)="toggle()"
      class="w-full flex items-center justify-between gap-2 h-11 px-3 text-xs border rounded-lg bg-white cursor-pointer transition-colors"
      [ngClass]="
        open()
          ? 'border-accent-500 ring-2 ring-accent-200'
          : error() && !value()
            ? 'border-red-400 ring-2 ring-red-100'
            : 'border-surface-400 hover:bg-surface-50'
      "
    >
      <span class="truncate" [ngClass]="selectedLabel() ? 'text-navy-900' : 'text-slate-400'">
        {{ selectedLabel() || placeholder() }}
      </span>
      <img
        src="/icons/chevron-down-icon.svg"
        class="w-3.5 h-3.5 shrink-0 transition-transform duration-150"
        [ngClass]="open() ? 'rotate-180' : ''"
        alt=""
      />
    </button>
  }

  <!-- Dropdown panel -->
  @if (open()) {
    <div
      class="fixed z-50 bg-white rounded-xl border border-surface-300 shadow-lg overflow-hidden min-w-40"
      [style.top.px]="openUpward() ? null : dropdownTop()"
      [style.bottom.px]="openUpward() ? dropdownBottom() : null"
      [style.left.px]="dropdownLeft()"
      [style.width.px]="dropdownWidth()"
    >
      @if (searchable()) {
        <div class="flex items-center gap-2 px-3 py-2 border-b border-slate-100">
          <img src="/icons/search-icon.svg" class="w-3.5 h-3.5 shrink-0 opacity-40" alt="" />
          <input
            type="text"
            placeholder="Search..."
            class="flex-1 text-xs border-0 p-0 bg-transparent focus:ring-0 focus:outline-none placeholder:text-slate-400"
            [value]="searchTerm()"
            (input)="onSearchInput($any($event.target).value)"
            (click)="$event.stopPropagation()"
          />
        </div>
      }
      <div class="overflow-y-auto max-h-56 py-1" (scroll)="onScroll($event)">
        @for (opt of sortedOptions(); track opt.value) {
          <button
            type="button"
            (click)="select(opt.value)"
            class="w-full text-left px-4 py-2.5 text-xs transition-colors cursor-pointer"
            [ngClass]="
              opt.value === value()
                ? 'bg-accent-50 text-accent-500 font-medium'
                : 'text-navy-900 hover:bg-surface-100'
            "
          >
            {{ opt.label }}
          </button>
        }
        @if (!sortedOptions().length && !loading()) {
          <div class="px-4 py-3 text-xs text-slate-400">No options available</div>
        }
        @if (loading()) {
          <div class="px-4 py-2.5 text-xs text-slate-400 text-center">Loading...</div>
        }
      </div>
    </div>
  }
</div>
